import { render } from "./UserCertificateUpload.vue?vue&type=template&id=6d1d563f&scoped=true"
import script from "./UserCertificateUpload.vue?vue&type=script&lang=js"
export * from "./UserCertificateUpload.vue?vue&type=script&lang=js"

import "./UserCertificateUpload.vue?vue&type=style&index=0&id=6d1d563f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d1d563f"]])

export default __exports__